import { render, staticRenderFns } from "./AppVersionManage.vue?vue&type=template&id=564da422&scoped=true"
import script from "./AppVersionManage.vue?vue&type=script&lang=js"
export * from "./AppVersionManage.vue?vue&type=script&lang=js"
import style0 from "./AppVersionManage.vue?vue&type=style&index=0&id=564da422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564da422",
  null
  
)

export default component.exports